import { isBusbudError } from "@app/helpers/api-error";
import type { Tracker } from "@app/tracking/tracker";

import {
  confirmSignIn,
  confirmSignUp
} from "../../../../../tracking/account-tracking";
import { failedRequest } from "../../../../../tracking/error-tracking";

type Provider = "google" | "facebook" | "apple";

export const trackClickedConnectSocial = (
  tracker: Tracker,
  is_sign_in: boolean,
  provider: Provider,
  auto_enrol_new_user?: boolean
) => {
  if (is_sign_in) {
    tracker.track(confirmSignIn(provider));
  } else {
    tracker.track(confirmSignUp(provider, auto_enrol_new_user));
  }
};

export const trackConnectSocialError = (
  tracker: Tracker,
  provider: Provider,
  provider_sdk_errors_to_ignore: string[],
  is_sign_in: boolean,
  err: Error | null
) => {
  if (
    !err ||
    !isBusbudError(err) ||
    provider_sdk_errors_to_ignore.includes(err.error)
  ) {
    return;
  }

  const connect_type = toConnectType(is_sign_in);
  tracker.track(failedRequest(err, connect_type, { error_provider: provider }));
};

function toConnectType(is_sign_in: boolean) {
  return is_sign_in ? "signin" : "signup";
}
